import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, LOGO, COLORS, COMPANY } from "@/lib/site";

export const Header = () => {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `font-medium transition-colors duration-150 ${
      isActive ? "text-[#0033A0]" : "text-[#1A1A1A] hover:text-[#0033A0]"
    }`;

  return (
    <header
      className="sticky top-0 z-50 bg-white border-b border-gray-200"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="site-logo-link" aria-label="Aumonline home">
          <img src={LOGO} alt="AUMONLINE" className="h-10 md:h-12 w-auto" data-testid="site-logo" />
        </Link>

        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink
              key={n.label}
              to={n.to}
              className={linkClass}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}-link`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            className="hidden md:inline-flex items-center gap-2 rounded-md px-5 py-2.5 text-white font-medium transition-colors duration-150 hover:opacity-90"
            style={{ backgroundColor: COLORS.blue }}
            data-testid="header-contact-btn"
          >
            Get in touch
          </Link>
          <button
            className="md:hidden p-2 text-[#1A1A1A]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-gray-200 px-4 py-4" data-testid="mobile-menu">
          <nav className="flex flex-col gap-4" aria-label="Mobile">
            {NAV.map((n) => (
              <NavLink
                key={n.label}
                to={n.to}
                onClick={() => setOpen(false)}
                className={linkClass}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              >
                {n.label}
              </NavLink>
            ))}
            <a
              href={`https://wa.me/${COMPANY.phoneRaw}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center justify-center rounded-md px-5 py-2.5 text-white font-medium"
              style={{ backgroundColor: COLORS.blue }}
              onClick={() => setOpen(false)}
              data-testid="mobile-contact-btn"
            >
              Get in touch
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
